export const iconFontAwesomeMapsSquarePhone = (
	<i className="fa-solid fa-square-phone"></i>
);
